import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { 
  LightMode as LightModeIcon, 
  DarkMode as DarkModeIcon 
} from '@mui/icons-material';
import { useThemeMode } from '../../contexts/ThemeContext';

const DarkModeToggle = ({ size = 'medium', showTooltip = true }) => {
  const { toggleTheme, isDark } = useThemeMode();

  const iconButton = (
    <IconButton
      onClick={toggleTheme}
      size={size}
      sx={{
        color: isDark ? '#FACC15' : '#FA9940',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          backgroundColor: isDark 
            ? 'rgba(250, 204, 21, 0.1)' 
            : 'rgba(250, 153, 64, 0.1)',
          transform: 'rotate(15deg) scale(1.1)',
        },
        '&:active': {
          transform: 'rotate(15deg) scale(0.95)',
        },
      }}
    >
      {isDark ? (
        <LightModeIcon 
          sx={{ 
            fontSize: size === 'small' ? '1.2rem' : size === 'large' ? '1.8rem' : '1.5rem',
            filter: 'drop-shadow(0 0 8px rgba(250, 204, 21, 0.3))',
          }} 
        />
      ) : (
        <DarkModeIcon 
          sx={{ 
            fontSize: size === 'small' ? '1.2rem' : size === 'large' ? '1.8rem' : '1.5rem',
            filter: 'drop-shadow(0 0 8px rgba(250, 153, 64, 0.3))',
          }} 
        />
      )}
    </IconButton>
  );

  if (!showTooltip) {
    return iconButton;
  }

  return (
    <Tooltip 
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      placement="bottom"
    >
      {iconButton}
    </Tooltip>
  );
};

export default DarkModeToggle;